module.exports = __webpack_public_path__ + "static/img/mobileproject.62c2ee4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/GreenIq/mobileproject.png
// module id = VS14
// module chunks = 0